import {
    setCookies
} from './_cookies'

export const wlSetGridState = () => {
    $('#myDillardsBar #dillards-wish-list').on('click', function() {
        setCookies("wl-grid-view", true);
    });
};
